import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faChevronDown,
    faEnvelope,
    faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import {
    faInstagram,
    faFacebookF,
    faTwitter,
    faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default () => {
    library.add(faChevronDown);
    library.add(faEnvelope);
    library.add(faPaperPlane);
    library.add(faInstagram);
    library.add(faFacebookF);
    library.add(faTwitter);
    library.add(faLinkedinIn);

    Vue.component('fa-icon', FontAwesomeIcon);
};
